import { useEffect, useState } from "react";
import api, { money } from "@/lib/api";
import { Card } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { Loader2, Gift, Crown, Zap } from "lucide-react";

export default function AgentBonuses() {
  const [data, setData] = useState(null);
  useEffect(() => {
    api.get("/agent/bonuses").then((r) => setData(r.data));
  }, []);

  if (!data) return <div className="flex justify-center py-24"><Loader2 className="w-6 h-6 animate-spin text-primary" /></div>;
  const m = (v) => money(v, data.currency, data.symbol);

  return (
    <div className="space-y-4">
      <h1 className="font-display text-2xl font-bold tracking-tight">Bonuses & milestones</h1>

      <Card className="p-5">
        <div className="flex items-center gap-2 mb-2">
          <Gift className="w-5 h-5 text-primary" />
          <h3 className="font-semibold">New-customer bonus</h3>
        </div>
        <p className="text-sm text-muted-foreground">
          {data.new_customers_cleared} new customers cleared this month · {m(data.new_customer_unit)} each
        </p>
        <p className="font-display text-2xl font-bold mt-2">{m(data.new_customer_bonus)}</p>
      </Card>

      <Card className="p-5">
        <div className="flex items-center gap-2 mb-2">
          <Crown className="w-5 h-5 text-amber-500" />
          <h3 className="font-semibold">Star agent</h3>
        </div>
        {data.is_star_agent ? (
          <>
            <Badge className="bg-amber-500/15 text-amber-600 border-amber-500/30">You're the top seller!</Badge>
            <p className="font-display text-2xl font-bold mt-2">{m(data.star_bonus)}</p>
          </>
        ) : (
          <p className="text-sm text-muted-foreground">
            Top seller of the month earns {m(data.star_bonus)}. Keep selling to claim it.
          </p>
        )}
      </Card>

      <Card className="p-5">
        <div className="flex items-center gap-2 mb-2">
          <Zap className="w-5 h-5 text-accent" />
          <h3 className="font-semibold">Accelerator</h3>
        </div>
        <p className="text-sm text-muted-foreground">
          Collected sales: {m(data.collected_sales)}
        </p>
        {data.accelerator_remaining > 0 ? (
          <p className="text-sm mt-1">{m(data.accelerator_remaining)} more to reach the next boost tier.</p>
        ) : (
          <p className="text-sm mt-1 text-primary">Top tier reached!</p>
        )}
      </Card>
    </div>
  );
}
